module.exports = __webpack_public_path__ + "media/icons/offer-details-ciezarowe@2x-5daf0870.png";